import React from "react";

const Error404 = () => {
  return (
    <div>
      <h1>404</h1>
      <p>Page not founded</p>
    </div>
  );
};

export default Error404;
